const analyticsEvents = {
  pageView: 'pageView',
  firstTimeVisit: 'First time visit',
  clickUpgrade: 'click on upgrade',
  clickLogin: 'click on login',
  loginSuccess: 'Login',
  clickCreateAccount: 'click on Create account',
  logout: 'Logout',
  clickUserMenu: 'click on user menu',
  clickPricing: 'click on pricing',
  clearAllTagsClicked: 'clear all tags clicked',
  clearTagClicked: 'clear tag clicked',
  subscribeClicked: 'subscribe clicked',
  clickStartFreeTrial: 'click on start free trial',
  clickStartWithPlan: 'click on start with',
  createTeamStep1: 'Click on create a team - step 1',
  createTeamStep2: 'Continue to create a team step 2',
  clickOnSubcategory: 'click on subcategory',
  filterSelected: 'filter selected',
  filterDeselected: 'filter deselected',
  filterMenuOpened: 'filter menu opened',
  sortBySelected: 'sort by selected',
  clickShare: 'User clicked the share button',
  clickShareMethod: 'User chose share method',
  searchAreaClicked: 'search clicked',
  searchTermTyped: 'search term typed',
  searchAutoCompleteReturnedEmpty: 'search auto complete returned empty',
  freeTextMediaSearched: 'free text media searched',
  suggestionSearchTermSelected: 'suggestion search term selected',
  searchReturnedEmpty: 'search returned empty',
  downloaded: 'downloaded',
  previewDownloaded: 'preview downloaded',
  downloadPreviewIconClicked: 'download preview icon clicked',
  mediaPlayed: 'media played',
  mediaViewed: 'media viewed',
  mediaPaused: 'media paused',
  register: 'register',
  clickOnAddToCollection: 'click on add to collection',
  assetAddedToCollection: 'asset added to collection',
  collectionCreated: 'collection created',
  videoPlayed: 'video played',
  registrationFailed: 'registration failed',
  loginFailed: 'login failed',
  clickOnSocialRegister: 'click on social register',
  clickOnSocialLogin: 'click on social login',
  clickOnEmailRegister: 'click on email register',
  myAccountArea: {
    menuOpened: 'menu opened',
    menuItemChosen: 'menu item chosen',
    tabSelected: 'tab selected',
    uploadButtonClicked: 'upload button clicked',
    myAccountUploadSaveButtonClicked: 'my account upload save button clicked',
    myAccountUploadCancelButtonClicked: 'my account upload cancel button clicked',
    shareButtonClicked: 'share button clicked', // old event used in laraval routes - account - not used by marketing
    shareMethodChosen: 'share method chosen', // old event used in laraval routes - account - not used by marketing
    createATeam: 'create a team',
    loggedOut: 'logged out',
  },
  clickOnShowFeatures: 'click on show features',
  clickOnGetStarted: 'click on get started',
  clickOnUpgrade: 'click on upgrade',
  clickOnDowngrade: 'click on downgrade',
  clickOnStartBrowsing: 'click on start browsing',
  clickSwitchPlan: 'click on switch plan',
  clickOnFollowArtist: 'click on follow artist',
  clickOnMessageArtist: 'click on message artist',
  sendEmailToArtist: 'send email to artist',
  clickOnShareArtistPage: 'click on share artist page',
  clickOnSendArtistReview: 'click on send artist review',
  clickOnArtistName: 'click on artist name',
  clickOnContinueToBrowse: 'click on continue browse',
  clickOnGetALicense: 'click on get a license',
  clickOnCategory: 'click on category',
  sendEmailButtonClicked: 'send email button clicked',
  downloadPopup: {
    downloadIconClicked: 'download icon clicked',
    popupOpen: 'popup open',
    approveEmailButtonClicked: 'send email button clicked',
    freeLeftAssetPopup: 'free left asset pop up viewed',
    clickOnLogin: 'click on login',
    clickOnStartFreeTrial: 'click on start free trial',
  },
  incentivePeriodStarted: 'incentive period started',
  signUpPopupOpened: 'sign up popup opened',
  clickExploreTheBlog: 'explore the blog clicked',
  signInPopupOpened: 'sign in popup opened',
  signupButtonClicked: 'signup button clicked',
  closeButtonClicked: 'close button clicked',
  subscribePaymentMethodSwitched: 'subscribe payment method switched',
  subscribePlanSwitched: 'subscribe plan switched',
  experimentStarted: 'experiment started',
  visit: 'visit',
  popupOpen: 'popup open',
  actionMenuOpened: 'action menu opened',
  numberOfSearchResultsReturned: 'number of search results returned',
  sectionViewed: 'section viewed',
  buttonClicked: 'button clicked',
  questionAnswered: 'question answered',
  checkboxTicked: 'checkbox ticked',
  actionCompleted: 'action completed',
  headerStripViewed: 'header strip viewed',
  textBoxClicked: 'text box clicked',
  textBoxFilled: 'text box filled',
  errorMsgPrompt: 'error msg prompt',
  mediaCardClicked: 'media card clicked',
  inputFilled: 'input filled',

  // Payment events
  paymentSucceed: 'payment succeed',
  paymentAttempted: 'payment attempted client',
  paymentFailed: 'payment failed',
  fieldInputError: 'field input error',
  addressFillComplete: 'address fill complete',
  vatViewed: 'vat viewed',
  discountViewed: 'discount viewed',
  inputInteracted: 'input interacted',
  vatFillComplete: 'vat fill complete',

  navigationClick: 'navigationClick',
  socialInteraction: 'socialInteraction',

  annotationClosed: 'annotation closed',
  packDownloaded: 'pack downloaded',
  stickyBannerClicked: 'sticky banner clicked',
  stickyBannerOpen: 'sticky banner open',
  stickyBannerClosed: 'sticky banner closed',
  reactivationBannerView: 'reactivation banner view',
  reactivationBannerClosed: 'reactivation banner closed',
  reactivationBannerClicked: 'reactivation banner clicked',

  // typeform events
  typeform: {
    answerReceived: 'answer received',
    modalOpen: 'type form modal open',
    submitted: 'type form submitted',
    closed: 'type form closed',
    questionChanged: 'type form question changed',
  },
  contactSalesButtonClicked: 'contact sales button clicked',
};
export default analyticsEvents;
